import { render } from "./tempalte.vue?vue&type=template&id=f518a1fc&scoped=true&ts=true"
import script from "./tempalte.vue?vue&type=script&lang=ts"
export * from "./tempalte.vue?vue&type=script&lang=ts"

import "./tempalte.vue?vue&type=style&index=0&id=f518a1fc&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f518a1fc"]])

export default __exports__